module.exports = __webpack_public_path__ + "static/media/engineerstudents_museumofart-14-2-1024x607.aa0ed725.jpg";